import axios from "../api/axios";
import useAuth from "./useAuth";
import {
  broadcastAuthCleared,
  broadcastAuthUpdated,
} from "../auth/authChannel";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {
    try {
      const response = await axios.get("backoffice/auth/refreshToken", {
        withCredentials: true,
      });

      const newAuth = {
        role: response.data.data.body.user.role,
        accessToken: response.data.data.body.accessToken,
      };

      setAuth((prev) => ({ ...prev, ...newAuth }));
      // Tell every other open tab about the new access token. Backend has
      // just revoked the previous one, so any tab still holding it would
      // start getting 443s on the next request.
      broadcastAuthUpdated(newAuth);

      return newAuth.accessToken;
    } catch (error) {
      console.error("Error refreshing token:", error);

      // Set auth state to inital, empty state
      setAuth({});
      broadcastAuthCleared();

      // Throw the error again to propagate it
      throw error;
    }
  };

  return refresh;
};

export default useRefreshToken;
